import React from 'react';
import { LayoutDashboard, Calendar, Target, Users, Filter, LineChart, Share2, Settings, HelpCircle } from 'lucide-react';
export function Sidebar() {
  return <div className="w-16 bg-[#2B3648] h-screen flex flex-col items-center py-4 justify-between fixed left-0 top-0 z-50" data-id="element-664">
      <div className="flex flex-col items-center space-y-6 w-full" data-id="element-665">
        <div className="w-8 h-8 bg-teal-500 rounded flex items-center justify-center text-white font-bold text-lg mb-4" data-id="element-666">
          W
        </div>

        <nav className="flex flex-col items-center space-y-4 w-full" data-id="element-667">
          <button className="p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors" data-id="element-668">
            <LayoutDashboard size={20} data-id="element-669" />
          </button>
          <button className="p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors" data-id="element-670">
            <Calendar size={20} data-id="element-671" />
          </button>
          <button className="p-2 text-teal-400 bg-teal-500/10 rounded-lg transition-colors w-10 h-10 flex items-center justify-center relative" data-id="element-672">
            <Target size={20} data-id="element-673" />
            <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-teal-500 rounded-r-full" data-id="element-674"></div>
          </button>
          <button className="p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors" data-id="element-675">
            <Users size={20} data-id="element-676" />
          </button>
          <button className="p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors" data-id="element-677">
            <Filter size={20} data-id="element-678" />
          </button>
          <button className="p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors" data-id="element-679">
            <LineChart size={20} data-id="element-680" />
          </button>
          <button className="p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors" data-id="element-681">
            <Share2 size={20} data-id="element-682" />
          </button>
          <button className="p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors" data-id="element-683">
            <Settings size={20} data-id="element-684" />
          </button>
        </nav>
      </div>

      <div className="flex flex-col items-center space-y-4" data-id="element-685">
        <button className="p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors" data-id="element-686">
          <HelpCircle size={20} data-id="element-687" />
        </button>
        <button className="w-8 h-8 rounded-full bg-gray-500 overflow-hidden border border-gray-600" data-id="element-688">
          <img src="https://i.pravatar.cc/150?img=11" alt="User Avatar" className="w-full h-full object-cover" data-id="element-689" />
        </button>
      </div>
    </div>;
}